import React from "react";

import { useProgressBarContext } from "../../../ProgressBarView/context/ProgressBarContext";
import { getProgressPercentage } from "../../../ProgressBarView/variants/version1/components/getBreakpointPosition";

import { Bar } from "./components/Bar";
import { Breakpoint } from "./components/Breakpoint";
import { Breakpoints } from "./components/Breakpoints";
import { Container } from "./components/Container";
import { PrimaryText } from "./components/PrimaryText";
import { ProgressBar } from "./components/ProgressBar";
import { SecondaryText } from "./components/SecondaryText";

export const ProgressBarWidget4 = () => {
  const { state } = useProgressBarContext();
  const progress = getProgressPercentage(state);

  return (
    <Container>
      <PrimaryText />
      <Bar
        innerCss={{
          padding: "0 0 0 0",
          height: 58,
        }}
      >
        <ProgressBar progress={progress} />
        <Breakpoints>
          {state.breakpoints.map((breakpoint, index) => (
            <Breakpoint key={index} index={index} breakpoint={breakpoint} />
          ))}
        </Breakpoints>
      </Bar>
      <SecondaryText />
    </Container>
  );
};
